'use client';
import { PieChart as PieChartComponent } from '../content-types/PieChart';
import { parseChartData } from '@/app/utils/parseChartData';

const PieChart = ({ ...props }) => {
    const attrsData = props?.attrs?.data || {};
    const { data: dataField, ...otherProps } = attrsData;

    const parsedData = parseChartData(dataField);

    return <PieChartComponent data={parsedData} {...otherProps} />;
};

export { PieChart };
